<ion-item class="ion-no-padding">
  <ion-label *ngIf="placeholder" position="floating" color="medium">
    {{ placeholder }}
  </ion-label>
  <ion-input [value]="formattedDate" readonly [id]="dateId" [readonly]="readonly"></ion-input>
</ion-item>
<ion-popover
  [trigger]="dateId"
  size="cover"
  showBackdrop="true"
  mode="ios"
  [arrow]="false"
  class="date-picker-popover ion-margin-top"
  *ngIf="!readonly"
>
  <ng-template>
    <ion-content scroll-y="false">
      <ion-datetime
        [value]="selectedDate"
        (ionChange)="onDateChange($event)"
        (ionCancel)="closeDatePicker()"
        presentation="date"
        class="floating-datetime"
      ></ion-datetime>
    </ion-content>
  </ng-template>
</ion-popover>
